import { ApolloError } from '@apollo/client';
import pino from 'pino';

export const pLogger = pino({
    enabled: !(process.env.LOG_ENABLED === 'false')
});

type LOG_LEVEL = 'log' | 'error' | 'warn';

// Change here to swap out current logger for something else
export const SERVER_LOGGER = console;
export const CLIENT_LOGGER = console;
export type LogType = Pick<Console, 'log' | 'warn' | 'error'>;

type Error = string | ApolloError | unknown;
type Info = string | unknown;
type Warning = string;

type Logger = (
    level: LOG_LEVEL,
    messages: Array<Error | Info | Warning>
) => void;
type LogBuilder = (logger: LogType) => Logger;

const buildLogger: LogBuilder =
    (logger) => (level: LOG_LEVEL, messages: Array<Error | Info | Warning>) => {
        if (level === 'error') {
            logger.error(...messages);
        } else if (level === 'warn') {
            logger.warn(...messages);
        } else if (level === 'log') {
            logger.log(...messages);
        }
    };
let logger: Logger = buildLogger(console);

export const setupLogger = (clientLogger: LogType, serverLogger: LogType) => {
    if (typeof window === 'undefined') {
        logger = buildLogger(serverLogger);
    } else {
        logger = buildLogger(clientLogger);
    }
};

export const logError = (...messages: Array<Error | Info | Warning>) => {
    logger('error', messages);
};

export const logInfo = (...messages: Array<Error | Info | Warning>) => {
    logger('log', messages);
};

export const logWarn = (...messages: Array<Error | Info | Warning>) => {
    logger('warn', messages);
};
